import React from "react";
import { calculateProductTotalPrice, formatPrice, getValidNumber } from "../helpers";
import * as S from "./styles";
export function OrderItem(_ref) {
  var e = _ref.product;
  var t, r, a, i;
  var l = (null == e ? void 0 : e.hasOwnProperty("boxImage")) && e.boxImage ? null === (r = null === (t = null == e ? void 0 : e.boxImage) || void 0 === t ? void 0 : t.fluid) || void 0 === r ? void 0 : r.src : null === (i = null === (a = null == e ? void 0 : e.productCardImage) || void 0 === a ? void 0 : a.fluid) || void 0 === i ? void 0 : i.src,
      d = getValidNumber(null == e ? void 0 : e.quantity, 1),
      o = calculateProductTotalPrice(e),
      c = formatPrice(o);
  return React.createElement(S.OrderItemContainer, null, React.createElement(S.OrderItemCol, {
    sm: 3
  }, React.createElement("img", {
    src: l,
    alt: e.displayName,
    width: 65,
    height: 40
  })), React.createElement(S.OrderItemDescription, {
    sm: 6
  }, e.displayName, React.createElement("div", {
    "data-testid": "order-item-product-".concat(e.id, "-quantity")
  }, "Quantity: ", d)), React.createElement(S.OrderItemPrice, {
    sm: 3
  }, React.createElement("span", {
    "data-testid": "order-item-product-".concat(e.id, "-totalPrice")
  }, "$", c)));
}
export default OrderItem;